import {register} from '../../../assets/js/modules/eventMap';
import {generateLiveRegion, getLiveRegion} from './utilities/liveRegion';
import {ACTIVE_CLASS, LIVE_REGION_TIMEOUT_MS} from './constants';

const copy = (button, value) => {
    navigator.clipboard
        .writeText(value)
        .then(() => {
            const buttonInitialText = button.querySelector(
                '[data-kinde-button-text]'
            );
            let buttonText;

            if (buttonInitialText) {
                buttonText = buttonInitialText.textContent;
                buttonInitialText.textContent =
                    getLiveRegion('copyToClipboardAlt');
            }

            button.classList.add(ACTIVE_CLASS);
            button.disabled = true;
            generateLiveRegion('copyToClipboard', true);

            setTimeout(() => {
                if (buttonText) {
                    buttonInitialText.textContent = buttonText;
                }

                button.classList.remove(ACTIVE_CLASS);
                button.disabled = false;
            }, LIVE_REGION_TIMEOUT_MS);
        })
        .catch((err) => {
            console.error('Kinde: Failed to copy to clipboard: ', err);
        });
};

const init = (el) => {
    if (!el) {
        return;
    }

    const value = el.value;

    copy(el, value);
};

const copyToClipboard = () => {
    register('copyToClipboard', {init});
};

export {copyToClipboard};
